import React from 'react';
import {
  Tabs,
  Tab,
  makeStyles,
  withStyles,
} from '@material-ui/core';

// Custom styles for the Tabs component
const useStyles = makeStyles((theme) => ({
  tabsRoot: {
    backgroundColor: '#f5f5f5',
    marginBottom: theme.spacing(0),
  },
  tabRoot: {
    minWidth: 100,
    color: 'darkblue',
    '&:hover': {
      color: 'white',
      opacity: 1,
    },
    '&$tabSelected': {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
    },
    '&:focus': {
      outline: 'none',               // remove focus outline
    },
  },
  tabSelected: {},
  indicator: {
    backgroundColor: theme.palette.primary.main,
    height: 3,
  },
}));

// Custom Tabs component
export default function CustomTabs({ tabs, value, onChange, className, disabled }) {
  const classes = useStyles();

  return (
    <Tabs
      value={value}
      onChange={onChange}
      classes={{
        root: classes.tabsRoot,
        indicator: classes.indicator,
      }}
      className={className}
      variant="scrollable"
      scrollButtons="auto"
    >
      {tabs.map((tab) => (
        <Tab
          disabled={disabled}
          key={tab.id}
          label={tab.title}
          classes={{
            root: classes.tabRoot,
            selected: classes.tabSelected,
          }}
        />
      ))}
    </Tabs>
  );
}
